import linkTo from 'linkTo';
import { SolidAnchorButton } from 'libs/core-components/SolidButton/SolidAnchorButton/SolidAnchorButton';
import React from 'react';
import { OAuthProvider } from 'pages/auth/types';
import { formatMessage } from '@99designs/frontend-components/i18n/index';
import VistaprintLogomark from 'common/Branding/Vistaprint/Logomark';
import { Source } from 'common/constants';

export interface OAuthLoginButtonProps {
    target?: string | null;
    provider: OAuthProvider;
    source?: Source;
}

const providerIcon = (provider: OAuthProvider) => {
    switch (provider) {
        case 'Vistaprint':
            return <VistaprintLogomark />;
        default:
            return null;
    }
};

export default function OAuthLoginButton({
    target = null,
    provider,
    source,
}: OAuthLoginButtonProps) {
    return (
        <SolidAnchorButton
            href={linkTo.authOAuthRedirect(provider, target, source)}
            data-testid="oauth-button"
            size="large"
            variant="secondary"
            width="fill"
            icon={providerIcon(provider)}
        >
            {formatMessage(__('Log in with {provider}'), {
                provider: provider,
            })}
        </SolidAnchorButton>
    );
}
